<template>
  <v-container fluid>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="mt-0 pt-0">
        <v-row class="mt-0 pt-0">
          <v-col class="col-12 pl-3 pr-3 mb-0 pt-0">
            <billingCard />
          </v-col>
          <v-col class="col-12 pl-3 pr-3 mb-0 pt-0"> <planCard /> </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
input {
  color: black !important;
}
</style>
<script>
import billingCard from "../billing-card";
import planCard from "../subscriptions";

export default {
  components: {
    billingCard,
    planCard
  },
  computed: {
    current_credit_card() {
      return "VISA **********4242";
    },
    current_plan() {
      return "Growth Plan";
    }
  }
};
</script>

<style></style>
